import PhoneInput from './js/PhoneInput';

export default PhoneInput;
